import { Divider, notification, Typography } from 'antd'
import Axios from 'axios'
import { SubmissionErrors } from 'final-form'
import React, { Fragment, useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { IPostRequestError } from '../../common/models'
import { dashboardRoutes } from '../../setup/config'
import { titles } from '../../setup/messages'
import GiftForm from './GiftForm'
import { IGift } from './models'

const NewGiftPage: React.FC = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)

  const onFormSubmit = useCallback(async (gift: IGift) => {
    const { name, cost, description, files, amount } = gift
    const data = new FormData()
    const file = files ? files[0] : null

    data.set('cost', cost.toString())
    if (description) {
      data.set('description', description)
    }
    data.set('name', name)
    if (amount !== undefined) {
      data.set('amount', amount.toString())
    }

    if (file) {
      data.append('file', file)
    }

    const endpoint = '/api/gifts'

    setLoading(true)

    try {
      await Axios.post(endpoint, data, {
        headers:
          { 'Content-Type': `multipart/form-data` }
      })

      setLoading(false)
      navigate(dashboardRoutes.giftsManagementPage)
      notification.success({
        message: 'Gift has been added'
      })
    } catch (err:any) {
      setLoading(false)

      const errors: IPostRequestError[] = err.response.data
      if (Array.isArray(errors)) {
        return errors.reduce(
          (obj: SubmissionErrors, item: IPostRequestError) => {
            if (item.param && item.msg && obj) {
              obj[item.param] = item.msg
            }
            return obj
          }, {})
      }
    }
  }, [navigate])

  const onCancel = useCallback(() => {
    navigate(dashboardRoutes.giftsManagementPage)
  }, [navigate])

  return (
    <Fragment>
              <Typography.Title level={2}>{titles.newGift}</Typography.Title>
      <Divider />
      <GiftForm
        loading={loading}
        onCancel={onCancel}
        onSubmit={onFormSubmit}
      />
    </Fragment>
  )
}
export default NewGiftPage
